import React, { useMemo } from 'react';
import classnames from 'classnames';
import Image from '../../components/Image/Image';
import Ribbon from '../../components/product-list/ribbon';
import { InternalLink } from '../../components/form-elements/Link';
import Currency from '../../../helpers/currency';
import { useSelector } from 'react-redux';
import { markenStandortSelector } from '../../../modules/selectors/standort/markenStandort';
import MerklisteButton from '../../routes/Merkliste/MerklisteButton';

function MoreProductsSliderCard({ product, forOffer, onClose }) {
    const to = useMemo(() => {
        return product.href || `/${product.categories[0]}/${product.id}`;
    }, [product]);
    const markenStandort = useSelector(markenStandortSelector)
    const isNoa = markenStandort.gesellschafterNr === "035";
    let isOfferActive = product.isDeliveryOfferActive || product.isPickUpOfferActive;

    return (
        <div className="uk-card uk-card-default uk-card-small uk-flex uk-flex-column" onClick={onClose}>
            <div className="uk-card-media-top uk-flex uk-flex-center uk-flex-middle" style={{ height: 200 }}>
                <Image src={product.imagelink} alt={product.bezeichnung} resizeHeight={200} fit="cover" />
            </div>
            {forOffer && <span className='artikelnummer'>Artikelnummer: {product.eigeneArtikelVarianten ? product.eigeneArtikelVarianten[0]?.shownId : product.id}</span>}
            <div className="uk-card-body uk-flex uk-flex-column uk-flex-1">
                <Ribbon product={product} isOfferActive={isOfferActive} fontsize={12}/>
                <div style={{ position: "absolute", right: 0, top: 174 }}>
                    <MerklisteButton productName={product.bezeichnung} productId={product.id} categoryUrl={product?.category ? product.category[0] : product?.categories[0]} selectedVariant={product.id} position="relative" />
                </div>
                <InternalLink to={to} modifier="reset">
                    <div className="uk-card-title cardTitle uk-text-bold" dangerouslySetInnerHTML={{ __html: product.bezeichnung }} style={{ fontSize: 16 }}></div>
                </InternalLink>
                <div className="uk-margin-auto-top">
                    <span className="uk-card-title uk-flex uk-flex-center">
                        {
                            (product.promotion !== "none" && product.originalPrice && product.originalPrice !== product.preisAb && isOfferActive) ?
                                <div className={classnames('promotionalPriceBox', { 'noaPrice': isNoa })}>
                                    <div className="oldPrice">
                                        <>
                                            {product.preisAb !== product.preisBis ? <span>ab </span> : <span>statt </span>}
                                            <span className='originalPrice' aria-label="ursprünglicher Preis"><Currency quantity={product.originalPrice} /></span>
                                        </>
                                    </div>
                                    <div className='newPrice' style={{ fontSize: 19.2 }}><Currency quantity={(product.preisAb || product.vk_preis)} /></div>
                                </div>
                                :
                                <div>
                                    <div className={classnames('priceProductCard', { 'noaPrice': isNoa })} style={{ fontSize: 19.2 }}>{product.preisAb !== product.preisBis && <span className='ab uk-margin-small-right'>ab </span>} <Currency quantity={(product.originalPrice || product.preisAb || product.vk_preis)} /></div>
                                </div>
                        }
                    </span>
                    <InternalLink to={to} fullWidth modifier="primary" className={product.soldOut ? "soldout-theme" : ""} ariaLabel={`Zum Produkt: ${product.bezeichnung.replace(/<[^>]*>/g, '')}`}>
                        ZUM PRODUKT
                    </InternalLink>
                </div>
            </div>
        </div>
    );
}

export default MoreProductsSliderCard;